import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import localize from 'components/Localize/Localize';

import styles from './ProductHeader.css';
import translations from './translations';

const cx = classNames.bind(styles);

class ProductHeader extends React.Component {
  render() {
    const descriptionClass = cx(`description`, {
      'description--hidden': this.props.hideDescription,
      [this.props.descriptionStyles]: this.props.descriptionStyles,
    });
    const { title, description } = this.props.t[`${this.props.productType}`];

    return (
      <div className={styles[`container--has-description`]}>
        <h1 className={styles[`title`]}>{title}</h1>
        <p className={descriptionClass}>{description}</p>
      </div>
    );
  }
}

ProductHeader.propTypes = {
  descriptionStyles: PropTypes.string,
  t: PropTypes.object.isRequired,
};

export default localize(ProductHeader, translations);
